import script from "./StickyBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./StickyBanner.vue?vue&type=script&setup=true&lang=js"

import "./StickyBanner.vue?vue&type=style&index=0&id=aae49abe&lang=scss"

const __exports__ = script;

export default __exports__